/*
 * Sidebar Component
 *
 * This contains all the text for the Sidebar Componen.
 */
import { defineMessages } from 'react-intl';

export const scope = 'boilerplate.components.Sidebar';

export default defineMessages({
  online: {
    id: `${scope}.status.online`,
    defaultMessage: 'Oniine',
  },
  idle: {
    id: `${scope}.status.idle`,
    defaultMessage: 'Idle',
  },
  bussy: {
    id: `${scope}.status.bussy`,
    defaultMessage: 'Bussy',
  },
  offline: {
    id: `${scope}.status.offline`,
    defaultMessage: 'Offline',
  },
  home: {
    id: `${scope}.home`,
    defaultMessage: 'Home',
  },
  landing_page: {
    id: `${scope}.home.landing_page`,
    defaultMessage: 'Landing Page',
  },
  corporate: {
    id: `${scope}.home.corporate`,
    defaultMessage: 'Corporate',
  },
  dashboard: {
    id: `${scope}.home.dashboard`,
    defaultMessage: 'Dashboard',
  },
  personal: {
    id: `${scope}.home.personal`,
    defaultMessage: 'Analytic',
  },
  crm: {
    id: `${scope}.home.crm`,
    defaultMessage: 'Marketing',
  },
  layouts: {
    id: `${scope}.home.layouts`,
    defaultMessage: 'Layouts',
  },
  grid: {
    id: `${scope}.home.grid`,
    defaultMessage: 'Grid',
  },
  application_layout: {
    id: `${scope}.home.application_layout`,
    defaultMessage: 'App Layout',
  },
  responsive: {
    id: `${scope}.home.responsive`,
    defaultMessage: 'Responsive',
  },
  tables: {
    id: `${scope}.tables`,
    defaultMessage: 'Tables Charts',
  },
  common_table: {
    id: `${scope}.tables.common_table`,
    defaultMessage: 'Tables Charts',
  },
  basic_table: {
    id: `${scope}.tables.basic_table`,
    defaultMessage: 'Basic',
  },
  data_table: {
    id: `${scope}.tables.data_table`,
    defaultMessage: 'Data Table',
  },
  table_playground: {
    id: `${scope}.tables.table_playground`,
    defaultMessage: 'Table Playgound',
  },
  redux_table: {
    id: `${scope}.tables.redux_table`,
    defaultMessage: 'Redux Table',
  },
  editable_cell: {
    id: `${scope}.tables.editable_cell`,
    defaultMessage: 'Table Edit',
  },
  svg_charts: {
    id: `${scope}.tables.svg_charts`,
    defaultMessage: 'SVG Chart',
  },
  line_charts: {
    id: `${scope}.tables.line_charts`,
    defaultMessage: 'Line',
  },
  bar_charts: {
    id: `${scope}.tables.bar_charts`,
    defaultMessage: 'Bar',
  },
  area_charts: {
    id: `${scope}.tables.area_charts`,
    defaultMessage: 'Area',
  },
  pie_charts: {
    id: `${scope}.tables.pie_charts`,
    defaultMessage: 'Pie & Doughnut',
  },
  radar_charts: {
    id: `${scope}.tables.radar_charts`,
    defaultMessage: 'Radar',
  },
  scatter_charts: {
    id: `${scope}.tables.scatter_charts`,
    defaultMessage: 'Scatter',
  },
  compossed_charts: {
    id: `${scope}.tables.compossed_charts`,
    defaultMessage: 'Compossed',
  },
  forms: {
    id: `${scope}.forms`,
    defaultMessage: 'Form Button',
  },
  buttons_collection: {
    id: `${scope}.forms.buttons_collection`,
    defaultMessage: 'Button Collection',
  },
  buttons: {
    id: `${scope}.forms.buttons`,
    defaultMessage: 'Button',
  },
  dial_button: {
    id: `${scope}.forms.dial_button`,
    defaultMessage: 'Dial Button',
  },
  toggle_button: {
    id: `${scope}.forms.toggle_button`,
    defaultMessage: 'Toggle Button',
  },
  text_input: {
    id: `${scope}.forms.text_input`,
    defaultMessage: 'Text Input',
  },
  textfields: {
    id: `${scope}.forms.textfields`,
    defaultMessage: 'Textfields',
  },
  autocomplete: {
    id: `${scope}.forms.autocomplete`,
    defaultMessage: 'Autocomplete & Tag',
  },
  datetimepicker: {
    id: `${scope}.forms.datetimepicker`,
    defaultMessage: 'Date Time Picker',
  },
  reduxform: {
    id: `${scope}.forms.reduxform`,
    defaultMessage: 'Redux Form',
  },
  selection: {
    id: `${scope}.forms.selection`,
    defaultMessage: 'Selection',
  },
  checkbox_radio: {
    id: `${scope}.forms.checkbox_radio`,
    defaultMessage: 'Checkbox & Radio',
  },
  switches: {
    id: `${scope}.forms.switches`,
    defaultMessage: 'Switches',
  },
  selectbox: {
    id: `${scope}.forms.selectbox`,
    defaultMessage: 'Select',
  },
  advanced_input: {
    id: `${scope}.forms.advanced_input`,
    defaultMessage: 'Advanced Input',
  },
  slider: {
    id: `${scope}.forms.slider`,
    defaultMessage: 'Slider Range',
  },
  upload: {
    id: `${scope}.forms.upload`,
    defaultMessage: 'Upload',
  },
  texteditor: {
    id: `${scope}.forms.texteditor`,
    defaultMessage: 'WYSIWYG Editor',
  },
  ui: {
    id: `${scope}.ui`,
    defaultMessage: 'UI Collection',
  },
  material_content: {
    id: `${scope}.ui.material_content`,
    defaultMessage: 'Block Containe',
  },
  card_papper: {
    id: `${scope}.ui.card_papper`,
    defaultMessage: 'Card & Papper',
  },
  accordion: {
    id: `${scope}.ui.accordion`,
    defaultMessage: 'Accordion',
  },
  material_navigation: {
    id: `${scope}.ui.material_navigation`,
    defaultMessage: 'Navigation',
  },
  tab: {
    id: `${scope}.ui.tab`,
    defaultMessage: 'Tabs Navigation',
  },
  drawer_menu: {
    id: `${scope}.ui.drawer_menu`,
    defaultMessage: 'Menu & Drawer',
  },
  breadcrumbs: {
    id: `${scope}.ui.breadcrumbs`,
    defaultMessage: 'Breadcrumbs',
  },
  steppers: {
    id: `${scope}.ui.steppers`,
    defaultMessage: 'Steppers',
  },
  material_popup: {
    id: `${scope}.ui.material_popup`,
    defaultMessage: 'Popup',
  },
  dialog_modal: {
    id: `${scope}.ui.dialog_modal`,
    defaultMessage: 'Dialog & Modal',
  },
  popover_tooltip: {
    id: `${scope}.ui.popover_tooltip`,
    defaultMessage: 'Popover & Tooltip',
  },
  material_notif: {
    id: `${scope}.ui.material_notif`,
    defaultMessage: 'Notification',
  },
  badges: {
    id: `${scope}.ui.badges`,
    defaultMessage: 'Badges',
  },
  snackbar: {
    id: `${scope}.ui.snackbar`,
    defaultMessage: 'Messages',
  },
  material_dividers: {
    id: `${scope}.ui.material_dividers`,
    defaultMessage: 'Dividers',
  },
  list_divider: {
    id: `${scope}.ui.list_divider`,
    defaultMessage: 'List & Divider',
  },
  material_image: {
    id: `${scope}.ui.material_image`,
    defaultMessage: 'Images',
  },
  avatars: {
    id: `${scope}.ui.avatars`,
    defaultMessage: 'Avatars',
  },
  image_gird: {
    id: `${scope}.ui.image_gird`,
    defaultMessage: 'Image Grid Gallery',
  },
  slider_carousel: {
    id: `${scope}.ui.slider_carousel`,
    defaultMessage: 'Slider & Carousel',
  },
  material_font_icon: {
    id: `${scope}.ui.material_font_icon`,
    defaultMessage: 'Fonts & Icons',
  },
  typography: {
    id: `${scope}.ui.typography`,
    defaultMessage: 'Typography',
  },
  icons: {
    id: `${scope}.ui.icons`,
    defaultMessage: 'Material Icons',
  },
  utilities: {
    id: `${scope}.ui.utilities`,
    defaultMessage: 'Utility',
  },
  progress: {
    id: `${scope}.ui.progress`,
    defaultMessage: 'Progress & Spinners',
  },
  tags: {
    id: `${scope}.ui.tags`,
    defaultMessage: 'Tags',
  },
  apps: {
    id: `${scope}.apps`,
    defaultMessage: 'Applications',
  },
  static_apps: {
    id: `${scope}.apps.static_apps`,
    defaultMessage: 'Static Apps',
  },
  contact: {
    id: `${scope}.apps.contact`,
    defaultMessage: 'Contact',
  },
  email: {
    id: `${scope}.apps.email`,
    defaultMessage: 'Email',
  },
  firebase_apps: {
    id: `${scope}.apps.firebase_apps`,
    defaultMessage: 'Firebase Apps',
  },
  contact_fullstack: {
    id: `${scope}.apps.contact_fullstack`,
    defaultMessage: 'Contact Firebase',
  },
  email_fullstack: {
    id: `${scope}.apps.email_fullstack`,
    defaultMessage: 'Email Firebase',
  },
  todo_fullstack: {
    id: `${scope}.apps.todo_fullstack`,
    defaultMessage: 'Todo',
  },
  maps: {
    id: `${scope}.apps.maps`,
    defaultMessage: 'Maps',
  },
  map_marker: {
    id: `${scope}.apps.map_marker`,
    defaultMessage: 'Map Marker',
  },
  map_direction: {
    id: `${scope}.apps.map_direction`,
    defaultMessage: 'Map Direction',
  },
  map_searchbox: {
    id: `${scope}.apps.map_searchbox`,
    defaultMessage: 'Map with Searchbox',
  },
  map_traffic: {
    id: `${scope}.apps.map_traffic`,
    defaultMessage: 'Traffic Indicator',
  },
  street_view: {
    id: `${scope}.apps.street_view`,
    defaultMessage: 'Street View',
  },
  pages: {
    id: `${scope}.pages`,
    defaultMessage: 'Pages',
  },
  account_page: {
    id: `${scope}.pages.account_page`,
    defaultMessage: 'Auth Page',
  },
  login: {
    id: `${scope}.pages.login`,
    defaultMessage: 'Login',
  },
  register: {
    id: `${scope}.pages.register`,
    defaultMessage: 'Register',
  },
  reset: {
    id: `${scope}.pages.reset`,
    defaultMessage: 'Reset Password',
  },
  auth_page: {
    id: `${scope}.pages.authenticated_page`,
    defaultMessage: 'Authenticated Page',
  },
  lock: {
    id: `${scope}.pages.lock`,
    defaultMessage: 'Lock Screen',
  },
  generic_page: {
    id: `${scope}.pages.generic_page`,
    defaultMessage: 'Generic',
  },
  user_profile: {
    id: `${scope}.pages.user_profile`,
    defaultMessage: 'User Profile',
  },
  blank: {
    id: `${scope}.pages.blank`,
    defaultMessage: 'Blank Page',
  },
  gallery: {
    id: `${scope}.pages.gallery`,
    defaultMessage: 'Photo Gallery',
  },
  maintenance: {
    id: `${scope}.pages.maintenance`,
    defaultMessage: 'Maintenance',
  },
  coming_soon: {
    id: `${scope}.pages.coming_soon`,
    defaultMessage: 'Coming Soon',
  },
  errors: {
    id: `${scope}.pages.errors`,
    defaultMessage: 'Errors',
  },
  not_found_page: {
    id: `${scope}.pages.not_found_page`,
    defaultMessage: 'Not Found Page',
  },
  widgets: {
    id: `${scope}.home.widgets`,
    defaultMessage: 'Widgets',
  },
  infographics_widget: {
    id: `${scope}.home.infographics_widget`,
    defaultMessage: 'Infographics',
  },
  status_widget: {
    id: `${scope}.home.status_widget`,
    defaultMessage: 'Status',
  },
  analytics_widget: {
    id: `${scope}.home.analytics_widget`,
    defaultMessage: 'Analytics',
  },
  mini_apps_widget: {
    id: `${scope}.home.mini_apps_widget`,
    defaultMessage: 'Mini Apps',
  },
  gallery_widget: {
    id: `${scope}.home.gallery_widget`,
    defaultMessage: 'Gallery',
  },
  social_page: {
    id: `${scope}.pages.social_page`,
    defaultMessage: 'Social Page',
  },
  timeline: {
    id: `${scope}.pages.timeline`,
    defaultMessage: 'Timeline',
  },
  chat: {
    id: `${scope}.pages.chat`,
    defaultMessage: 'Chat',
  },
  ecommerce: {
    id: `${scope}.pages.ecommerce`,
    defaultMessage: 'E-commerce',
  },
  itemlist: {
    id: `${scope}.pages.itemlist`,
    defaultMessage: 'Product Catalogues',
  },
  item_detail: {
    id: `${scope}.pages.item_detail`,
    defaultMessage: 'Product Detail',
  },
  checkout: {
    id: `${scope}.pages.checkout`,
    defaultMessage: 'Checkout Page',
  },
  dynamic_invoice: {
    id: `${scope}.pages.dynamic_invoice`,
    defaultMessage: 'Dynamic Invoice',
  },
  error_page: {
    id: `${scope}.pages.errors`,
    defaultMessage: 'Error Page',
  },
  menu_levels: {
    id: `${scope}.menu_levels`,
    defaultMessage: 'Menu Levels',
  },
  level_1: {
    id: `${scope}.level_1`,
    defaultMessage: 'Level 1',
  },
  level_2: {
    id: `${scope}.level_2`,
    defaultMessage: 'Level 2',
  },
  sub_menu_1: {
    id: `${scope}.sub_menu_1`,
    defaultMessage: 'Sub Menu 1',
  },
  sub_menu_2: {
    id: `${scope}.sub_menu_2`,
    defaultMessage: 'Sub Menu 2',
  },
});
